<template>
  <div class="wizard-section">
    <div class="wizard-section__meta">
      <span
        v-if="optional"
        class="wizard-section__optional-pill eyebrow-label eyebrow-label--sm"
      >
        {{ $t("common.optional") }}
      </span>
      <h5 class="wizard-section__title">
        <FontAwesomeIcon
          v-if="icon"
          :icon="icon"
          class="wizard-section__icon"
        />
        {{ title }}
      </h5>
      <p v-if="description" class="wizard-section__description">
        {{ description }}
      </p>
    </div>
    <div class="wizard-section__body">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

defineProps<{
  title: string;
  description?: string;
  optional?: boolean;
  icon?: string | string[];
}>();
</script>

<style scoped lang="scss">
.wizard-section {
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 24px;
  align-items: start;
  padding: 22px 28px;
  border-bottom: 1px solid var(--phoenix-border-color-translucent);

  &:last-child {
    border-bottom: 0;
  }
}

.wizard-section__meta {
  padding-top: 2px;
}

.wizard-section__optional-pill {
  background: var(--phoenix-gray-100);
  padding: 2px 8px;
  border-radius: 999px;
  margin-bottom: 8px;
}

.wizard-section__title {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 700;
  color: var(--phoenix-gray-1000);
  letter-spacing: -0.005em;
}

.wizard-section__icon {
  margin-right: 8px;
  color: var(--phoenix-gray-500, #7d8478);
  font-size: 0.9em;
}

.wizard-section__description {
  margin: 0;
  font-size: 13px;
  color: var(--phoenix-gray-500);
  line-height: 1.45;
}

.wizard-section__body {
  min-width: 0; // prevent grid overflow
}

@media (max-width: 768px) {
  .wizard-section {
    grid-template-columns: 1fr;
    gap: 12px;
    padding: 18px 16px;
  }
}
</style>
